import Vue from 'vue'

Vue.component('FeatherIcon', resolve => import(/* webpackChunkName: "feather" */ '@core/components/feather-icon/FeatherIcon.vue').then(resolve))
